/**
 * Reviews (WP3-REVIEWS, BUILD-PLAN M13): review feed with guarded replies,
 * request engine without gating, campaigns, rating trends per office and the
 * patient review page. Lives under Patients in the side nav (BUILD-PLAN 3.4).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'reviews',
    title: 'Reviews',
    version: '0.1.0',
    owner: 'WP3-REVIEWS',
    entitlementKey: 'reviews',
    permissions: ['comms.view', 'comms.send', 'settings.manage', 'patient.view'],
    routes: [
      {
        id: 'reviews',
        path: '/reviews',
        title: 'Reviews',
        officeScope: 'location-or-all',
        permission: 'comms.view',
        // The internal patient match (PHI) is shown to permitted roles and audited per read.
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Reviews',
        group: 'patients',
        routeId: 'reviews',
        icon: 'star',
        order: 40,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'reviews.open',
        title: 'Go to Reviews',
        keywords: ['google', 'reputation', 'rating', 'reply', 'feedback'],
        routeId: 'reviews',
        permission: 'comms.view',
      },
      {
        id: 'reviews.requests',
        title: 'Review requests: Feedback & Requests, Quick Send',
        keywords: [
          'review requests',
          'ask for reviews',
          'quick send',
          'doctible',
          'csv',
          'activity',
          'sent history',
        ],
        routeId: 'reviews',
        search: { tab: 'requests' },
        permission: 'comms.view',
      },
      {
        id: 'reviews.daily',
        title: 'Daily Review: confirm and send review requests',
        keywords: ['daily review', 'confirm and send', 'yesterday', 'doctible'],
        routeId: 'reviews',
        search: { tab: 'daily' },
        permission: 'comms.view',
      },
      {
        id: 'reviews.settings',
        title: 'Review request settings: automate, templates, magic link',
        keywords: [
          'review settings',
          'automate review requests',
          'magic link',
          'templates',
          'doctible',
          'turn on reviews',
          'spanish',
        ],
        routeId: 'reviews',
        search: { tab: 'settings' },
        permission: 'comms.view',
      },
      {
        id: 'reviews.feedback',
        title: 'Private feedback from patients',
        keywords: ['private feedback', 'complaints', 'unhappy', 'how can we improve'],
        routeId: 'reviews',
        search: { tab: 'requests' },
        permission: 'comms.view',
      },
    ],
    shortcuts: [{ keys: 'g v', description: 'Go to Reviews', routeId: 'reviews' }],
    sseEntityKeys: ['review'],
    phiReadPoints: ['reviews.match'],
  }),
  pages: {
    reviews: () => import('./ReviewsPage.js'),
  },
});
